<template>
  <section class="loginReg" :style="{'--panelColor': panelColor}">
    <div class="loginReg-header-container">
      <img :src="accessConfig.headerLogo" alt>
    </div>
    <div class="loginReg-container">
      <img class="loginReg-background-img" :src="accessConfig.forgetPasswordView.bg ? accessConfig.forgetPasswordView.bg : accessConfig.loginView.bg">
      <div class="loginReg-first-container" v-if="accessConfig.forgetPasswordView.position=='right'">
        <transition appear name="translate">
        <div class="loginReg-eventLogo" v-html="accessConfig.forgetPasswordView.eventLogo ? accessConfig.forgetPasswordView.eventLogo : accessConfig.loginView.eventLogo"></div>      
        </transition>
      </div>
      <div class="loginReg-second-container">
        <div class="register-title" v-html="accessConfig.forgetPasswordView.forgetContainer"></div>
        <div class="inputs-wrapper">
          <div :class="{'email-input-wrapper':!shake, 'email-input-wrapper shakeAnimation':shake}">
            <ion-icon class="ionicon-icon" name="mail-outline"></ion-icon>
            <input class="email-input" type="text" :placeholder="accessConfig.forgetPasswordView.idPlaceholder" @keypress="checkKey" v-model="username">
          </div>
          <button class="enter-and-send-btn" @click.prevent="forgetPassword"><p v-html="accessConfig.forgetPasswordView.buttonText"></p></button>
          <div class="bottom-instructions">
            <a class="login-forgot-password" href="#/login"><p v-html="accessConfig.forgetPasswordView.backButtonText"></p></a>            
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </section> 
</template>


<script>
import api from '@/services/api';
import Footer from '@/components/general/Footer.vue';

export default {
  name: 'ForgetPassword',
  template: `<input v-bind:value="value" v-on:input="$emit('input', $event.target.value)">`,
  components: { Footer },

  data() {
    return {
      username: '',
      password: '',
      shake: false,
      accessConfig: {},
      panelColor: 'transparent',
    };
  },

  mounted() {
    this.username = this.$store.state.username;
  },
  methods: {
    checkKey(key) {
      if (key.keyCode == 13) this.forgetPassword();
    },

    forgetPassword() {
      if (this.username.length > 0) {
        api
          .post(`event/${this.$store.state.eventId}/forgetPassword`, { email: this.username })
          .then(response => {
            //console.log(response);
            this.$modal.show('dialog', {
              title: '',
              text: this.accessConfig.forgetPasswordView.successMessage ? this.accessConfig.forgetPasswordView.successMessage : 'Sucesso!',
              buttons: [
                {
                  title: 'Ok',
                  handler: () => {
                    this.$modal.hide('dialog');
                    this.$router
                      .push({
                        name: 'Login',
                      })
                      .catch(err => {
                        console.log('navigation error', err);
                        alert(this.accessConfig.forgetPasswordView.failMessage ? this.accessConfig.forgetPasswordView.failMessage : 'Seu acesso falhou, por favor revise suas informações e tente novamente.');
                      });
                    this.$emit('close');
                  },
                },
              ],
            });
            // alert(this.accessConfig.forgetPasswordView.successMessage ? this.accessConfig.forgetPasswordView.successMessage : 'Sucesso!');
          })
          .catch((err, data) => {
            console.log('error', err.response, data);

            this.$modal.show('dialog', {
              title: '',
              text: this.accessConfig.forgetPasswordView.failMessage ? this.accessConfig.forgetPasswordView.failMessage : 'Seu acesso falhou, por favor revise suas informações e tente novamente.',
              buttons: [
                {
                  title: 'Ok',
                  handler: () => {
                    this.$modal.hide('dialog');
                  },
                },
              ],
            });
            // alert(this.accessConfig.forgetPasswordView.failMessage ? this.accessConfig.forgetPasswordView.failMessage : 'Seu acesso falhou, por favor revise suas informações e tente novamente.');
          });
      } else {
        this.shake = true;
        setTimeout(() => {
          this.shake = false;
        }, 500);
        // alert('Acho que esqueceu de digitar o email. Não deixe o campo em branco.');
      }
    },
  },
  beforeMount() {
    this.accessConfig = this.$store.state.template.accessConfig;
    if (this.accessConfig.loginView.panelColor) this.panelColor = this.accessConfig.loginView.panelColor;
  },
};
</script>


<style lang="scss">
</style>
